import filtersDisplayConfig from "./filtersDisplay.config";
import apiPathsConfig from './apiPaths.config';
import PlaylistsTableListItem from "../PlaylistsListItem/PlaylistsTableListItem.vue";
import availableActionsConfig from "./availableActions.config";
import availableListViewsConfig from "./availableListViews.config";
import listNamesConfig from "./listNames.config";
import tableColumnsConfig from "./tableColumns.config";

const itemsListerConfig = {
  TableViewItem: PlaylistsTableListItem,
  apiPathsConfig,
  filtersDisplayConfig,
  availableActionsConfig,
  availableListViewsConfig,
  columns: tableColumnsConfig,
  ...listNamesConfig
}

export default itemsListerConfig;